module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"amount":"Valor","status":"Situação"},"en-US":{"amount":"Amount","status":"Status"}}')
  delete Component.options._Ctor
}
